import { translateEntity } from "@shared/modules/localization/utils/caseEntityTranslation";
import { caseEntityTypesMap } from "@shared/modules/localization/utils/caseEntityTranslation/constants";
import { FORM_ENTITY_TYPE_MAP } from "./constants"

const propertiesToSkip = [
  "type",
]
const propertyEndingsToSkip = [
  "status",
  "id",
  "internal_name",
  "entity_type",
  "option_value"
]

const valuesToSkipChecks = [
  (prop) => typeof prop !== "string",
]

const propertiesToSkipChecks = [
  (prop) => propertyEndingsToSkip.some((part) => prop.endsWith(part)),
  (prop) => propertiesToSkip.includes(prop),
]

const formTypesMap = {
  [FORM_ENTITY_TYPE_MAP.SECTION]: caseEntityTypesMap.SECTION,
  [FORM_ENTITY_TYPE_MAP.BLOCK]: caseEntityTypesMap.BLOCK,
  [FORM_ENTITY_TYPE_MAP.FIELD]: caseEntityTypesMap.FIELD,
}

const getFormEntityType = (entity) => {
  const entityType = entity.form_entity_type;
  if (!entityType && entity.section_id) return formTypesMap.SECTION;
  return formTypesMap[entityType] || caseEntityTypesMap.FIELD;
}

export const translateFormEntity = (entity, type) => {
  const entityType = type ?? getFormEntityType(entity);
  const propsToTranslate = Object.entries(entity)
    .filter(([key, value]) => !propertiesToSkipChecks.some((check) => check(key)) && !valuesToSkipChecks.some((check) => check(value)))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
    const translatedProps = translateEntity(propsToTranslate, entityType);

  return {...entity, ...translatedProps};
}